export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./link-back.vue?vue&type=template&id=7ff120e3&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/link-back/link-back.vue?vue&type=template&id=7ff120e3&
// module id = 1367
// module chunks = 0